import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import debounce from 'lodash.debounce';
import { CTA, CustomSelect, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { TUTOR_LIST_GET } from '../../../../app/redux/actions/supervisorStats';
import { TutorCard } from './style';

export const ModalSelectTutorId = 'ModalSelectTutor';

const ModalSelectTutor = ({
  onConfirm,
  mediaIsPhone,
  list,
  getTutorList,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);
  const [options, setOptions] = useState([]);
  const [searchValue, setSearchValue] = useState();
  const [selectedTutor, setSelectedTutor] = useState({});

  useEffect(() => {
    if (searchValue?.length > 1) getTutorList({ search_text: searchValue });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (list?.length > 0) {
      setOptions(
        list.map((u) => ({
          label: `${u?.name} ${u?.surname}`,
          value: u?.uid,
          matricola: u?.matricola,
        }))
      );
    }
  }, [list]);

  return (
    <Modal
      title="Ricerca per tutor"
      description="Sezione dedicata alla ricerca del tutor. Inizia a scriverne il nome e seleziona il tutor desiderato."
      modalId={ModalSelectTutorId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <CustomSelect
        size="full"
        placeholder="Cerca il tutor?..."
        isSearch
        value=""
        icon="search-sm"
        isSearchable
        onInputChange={debounce((v) => {
          if (v?.length > 2) setSearchValue(v);
        }, 500)}
        onChange={(v) => setSelectedTutor(v)}
        alwaysEnabled
        options={options}
        selected={[]}
      />
      <ScrollableArea ref={scrollableAreaRef}>
        {selectedTutor?.value ? (
          <>
            <Text type="b3" mt={32} mb={24}>
              Tutor aggiunto
            </Text>
            <TutorCard>
              <Text type="h3">{selectedTutor?.label}</Text>
              {selectedTutor?.matricola && (
                <Text type="b3">Matricola: {selectedTutor?.matricola}</Text>
              )}
              <CTA
                type="tertiary"
                btnText="Rimuovi"
                icon="x"
                bottomRight
                onClick={() => setSelectedTutor()}
              />
            </TutorCard>
          </>
        ) : (
          <Text type="b3" mt={32} mb={300}>
            Nessun tutor visualizzato
          </Text>
        )}
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="Salva"
          fullsize={mediaIsPhone}
          onClick={() => {
            onConfirm(selectedTutor);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalSelectTutor.propTypes = {
  onConfirm: PropTypes.func,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  list: PropTypes.array,
  // dispatch
  getTutorList: PropTypes.func,
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { list } = state.supervisorStats.lists.tutors;
      return { list };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getTutorList: (filters) =>
        dispatch({ type: TUTOR_LIST_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalSelectTutor);
